import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", null, "采购系统", -1);
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, "系统首页", -1);
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, "产品管理", -1);
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "产品列表", -1);
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, "产品分类", -1);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_menu_item = _resolveComponent("el-menu-item");
  const _component_Briefcase = _resolveComponent("Briefcase");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_Grid = _resolveComponent("Grid");
  const _component_el_menu_item_group = _resolveComponent("el-menu-item-group");
  const _component_el_sub_menu = _resolveComponent("el-sub-menu");
  const _component_el_menu = _resolveComponent("el-menu");
  return _openBlock(), _createBlock(_component_el_menu, {
    "default-active": $setup.route.path,
    class: "el-menu-vertical",
    collapse: $props.isClose,
    "background-color": "#112f50",
    "text-color": "#fff",
    "active-text-color": "#ffd04b",
    router: ""
  }, {
    default: _withCtx(() => [_createVNode(_component_el_menu_item, null, {
      title: _withCtx(() => [_hoisted_1]),
      _: 1
    }), _createVNode(_component_el_menu_item, {
      index: "/"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_icon, null, {
        default: _withCtx(() => [_createVNode(_component_Briefcase)]),
        _: 1
      }), _hoisted_2]),
      _: 1
    }), _createVNode(_component_el_sub_menu, {
      index: "/goods"
    }, {
      title: _withCtx(() => [_createVNode(_component_el_icon, null, {
        default: _withCtx(() => [_createVNode(_component_Grid)]),
        _: 1
      }), _hoisted_3]),
      default: _withCtx(() => [_createVNode(_component_el_menu_item_group, null, {
        default: _withCtx(() => [_createVNode(_component_el_menu_item, {
          index: "/goods/list"
        }, {
          default: _withCtx(() => [_hoisted_4]),
          _: 1
        }), _createVNode(_component_el_menu_item, {
          index: "/goods/category"
        }, {
          default: _withCtx(() => [_hoisted_5]),
          _: 1
        })]),
        _: 1
      })]),
      _: 1
    })]),
    _: 1
  }, 8, ["default-active", "collapse"]);
}